import { render, staticRenderFns } from "./FiltroAutor.vue?vue&type=template&id=35093b2a"
import script from "./FiltroAutor.vue?vue&type=script&lang=js"
export * from "./FiltroAutor.vue?vue&type=script&lang=js"
import style0 from "./FiltroAutor.vue?vue&type=style&index=0&id=35093b2a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports